.logo {
    width: 100%;
}
